// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3UPff","name":"Header_name__1mPmr","birthday":"Header_birthday__26hBB","skeleton":"Header_skeleton__3ug2h"};